import React, { useState } from "react";
import "./SocialMediaBar.css";
import {
  FaFacebookF,
  FaInstagram,
  FaYoutube,
  FaLinkedinIn,
  FaChevronLeft,
  FaChevronRight,
  FaWhatsapp,
} from "react-icons/fa";
import { BsChatLeftDots } from "react-icons/bs";
// Assuming this is the correct path for your ChatWidget file
import ChatWidget from "../ChatWidget"; 

const SocialMediaBar = () => {
  const [isOpen, setIsOpen] = useState(true);
  // 💡 New state to control the ChatWidget popup visibility
  const [isChatOpen, setIsChatOpen] = useState(false); 

  // 💡 Handler function to open the chat popup
  const handleChatIconClick = (e) => {
    // e.preventDefault(); // Prevent the default link behavior
    setIsChatOpen(true);
  };

  // 💡 Handler function to close the chat popup
  const handleChatClose = () => {

    setIsChatOpen(false);
  };

  return (
    <>
      <div className={`floating-social-bar ${isOpen ? "open" : "closed"}`}>
        <div className="toggle-btn" onClick={() => setIsOpen(!isOpen)}>
          {isOpen ? <FaChevronRight /> : <FaChevronLeft />}
        </div>

        <div className="icon-list">
          {/* 💡 CHAT ICON MODIFIED to call handleChatIconClick */}
          <a
            href="#"
            onClick={()=>{handleChatIconClick(); setIsOpen(!isOpen)}}
            title="Chat with Agent"
          >
            <BsChatLeftDots />
          </a>
          <a
            href="https://api.whatsapp.com/send/?phone=919891113123&text=Hi, I saw the diet plans on your website. Can you please suggest me which is the best plan for me?&type=phone_number&app_absent=0"
            target="_blank"
            rel="noopener noreferrer"
            title="WhatsApp"
          >
            <FaWhatsapp />
          </a>
          <a
            href="https://www.instagram.com/fitojaapp/"
            target="_blank"
            rel="noopener noreferrer"
            title="Instagram"
          >
            <FaInstagram />
          </a>
          <a
            href="https://www.linkedin.com/company/fitoja/"
            target="_blank"
            rel="noopener noreferrer"
            title="LinkedIn"
          >
            <FaLinkedinIn />
          </a>
          <a
            href="https://www.youtube.com/@FITOJATEAM/shorts"
            target="_blank"
            rel="noopener noreferrer"
            title="YouTube"
          >
            <FaYoutube />
          </a>
          <a
            href="https://www.facebook.com/profile.php?id=61573268400280"
            target="_blank"
            rel="noopener noreferrer"
            title="Facebook"
          >
            <FaFacebookF />
          </a>
        </div>
      </div>
      
      {/* 💡 Conditionally render the ChatWidget as a controlled component */}
      {isChatOpen && (
          <ChatWidget 
              isControlledOpen={isChatOpen} 
              onClose={handleChatClose} 
          />
      )}
    </>
  );
};

export default SocialMediaBar;